module.exports = __webpack_public_path__ + "static/media/reading.6a40a757.mp3";